import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translate } from "@/lib/i18n";

const LangCtx = createContext(null);

export function LanguageProvider({ children, initial = "en" }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hag_lang") || initial);

  useEffect(() => {
    localStorage.setItem("hag_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translate(lang, key);
  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));

  return <LangCtx.Provider value={{ lang, setLang, toggle, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
